import React from 'react';

import Button from '@mui/material/Button';
import cx from 'classnames';

import useStyles from './styles';

export enum BUTTON_VARIANT {
  Contained = 'contained',
  Outlined = 'outlined',
}

export enum BUTTON_COLOR {
  Primary = 'primary',
  Secondary = 'secondary',
}

interface CustomButtonProps {
  btnClass?: string;
  className?: string;
  children: React.ReactNode;
  onClick?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  color?: 'primary' | 'secondary';
  variant?: 'contained' | 'outlined';
  disabled?: boolean;
  disabledClass?: string;
  type?: 'button' | 'submit';
  id?: string;
  'data-testid'?: string;
}

const CustomButton: React.FC<CustomButtonProps> = ({
  children,
  btnClass,
  onClick,
  color = BUTTON_COLOR.Primary,
  variant = BUTTON_VARIANT.Outlined,
  disabled = false,
  disabledClass,
  type = 'button',
  id,
  ...rest
}) => {
  const classes = useStyles();

  return (
    <Button
      id={id}
      variant={variant}
      color={color}
      className={cx(classes.btn, btnClass, rest?.className)}
      onClick={onClick}
      disabled={disabled}
      type={type}
      classes={{
        contained: classes.btnContained,
        outlined: classes.btnOutlined,
        containedPrimary: classes.btnContainedPrimary,
        containedSecondary: classes.btnContainedSecondary,
        outlinedPrimary: classes.btnOutlinedPrimary,
        outlinedSecondary: classes.btnOutlinedSecondary,
        disabled: cx(classes.btnDisabled, disabledClass),
      }}
      data-testid={rest['data-testid']}
    >
      {children}
    </Button>
  );
};

export default CustomButton;
